// src/store/slices/registerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const submitVendorDetails = createAsyncThunk(
  "register/submitVendorDetails",
  async (details, thunkAPI) => {
    try {
      const res = await fetch("/api/vendor/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(details),
      });
      const data = await res.json();
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

const registerSlice = createSlice({
  name: "vendorRegister",
  initialState: {
    vendorData: null,
    isRegistered: false,
    loading: false,
    error: null,
  },
  reducers: {
    resetRegistration(state) {
      state.vendorData = null;
      state.isRegistered = false;
      state.error = null;
    },
    setIsRegistered(state, action) {
      state.isRegistered = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(submitVendorDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitVendorDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.vendorData = action.payload;
        state.isRegistered = true;
      })
      .addCase(submitVendorDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetRegistration, setIsRegistered } = registerSlice.actions;
export default registerSlice.reducer;
